
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/suche/[...slugs]",
      function () {
        return require("private-next-pages/[lang]/suche/[...slugs].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/suche/[...slugs]"])
      });
    }
  